import { stdObject } from "../../../../data/types/stdObject";

export const deleteOffer = (
  country: string,
  index: number,
  params: stdObject,
) => {
  const { windowValues2, setWindowValues2 } = params;
  const updatedOffers = windowValues2.PRE.offers[country].filter(
    (_: stdObject, i: number) => i !== index,
  );
  setWindowValues2({
    ...windowValues2,
    PRE: {
      ...windowValues2.PRE,
      offers: { ...windowValues2.PRE.offers, [country]: updatedOffers },
    },
  });
};
